import { Loader } from '@googlemaps/js-api-loader';

const googleMap = document.querySelector('[data-ecopark-google-map]');
const googleMapLat = Number(googleMap ? googleMap.getAttribute('data-lat') : 0);
const googleMapLng = Number(googleMap ? googleMap.getAttribute('data-lng') : 0);
const mapsmarkers = [];

export function setMarkers(map) {
    /* eslint-disable no-undef */
    const marker = new google.maps.Marker({
        position: new google.maps.LatLng(googleMapLat, googleMapLng),
        map,
        icon: '/img/custom/markers/default.png',
    });
    /* eslint-enable no-undef */

    mapsmarkers.push(marker);
}

export function loadMap() {
    googleMap.classList.remove('hidden');

    /* eslint-disable no-undef */
    const mapsConfig = {
        mapTypeId: 'satellite',
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        zoom: 15,
        center: {
            lat: googleMapLat,
            lng: googleMapLng,
        },
    };

    if (window.innerWidth <= 768) {
        mapsConfig.draggable = true;
        mapsConfig.zoomControl = true;
    }

    const map = new google.maps.Map(googleMap, mapsConfig);
    /* eslint-enable no-undef */

    setMarkers(map);
}

export default function initMaps() {
    if (googleMap) {
        const loader = new Loader({
            apiKey: 'AIzaSyCRyrckY_z9CxzOHzL4-7KoYRY1nSO1sW4',
            language: 'nl_NL',
            version: 'weekly',
        });
        loader.load()
            .then(() => {
                loadMap();
            });
    }
}
